import { render, staticRenderFns } from "./ApexLineAreaChart.vue?vue&type=template&id=20835c2a&"
import script from "./ApexLineAreaChart.vue?vue&type=script&lang=js&"
export * from "./ApexLineAreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports